import GTM_FROM_LS_RECORD from 'shared-constants/src/fromGTMLSRecord';

import { setItem } from '../localStorage';

export default ({
  url,
  value,
  eventsList,
}) => {
  /**
   * salvo il record con:
   * la url di destinazione come chiave dell'oggetto
   * il referrer, per assicurarmi gli eventi stiano effettivamente seguendo il flusso desiderato
   * il valore da settare nel from
   * la lista degli eventi per cui bisognerà settare il from
   */
  setItem(GTM_FROM_LS_RECORD, {
    [url]: {
      referrer: document.location.href,
      value,
      eventsList,
    },
  });
};
